module.exports = __webpack_public_path__ + "gu.svg?2ca576950914780b70ea5115de53f9c9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gu.svg
// module id = 1074
// module chunks = 27